import {useState} from "react";
import {Link} from "react-router-dom";
import {cx} from "class-variance-authority";
import {LayoutDashboard, FileText, Eye} from "lucide-react";
import SidebarChevron from "@/assets/icons/SidebarChevron";
import {
  Dropdown,
  DropdownTrigger,
  DropdownContent,
  DropdownItem,
} from "@/components/ui/dropdown";

export default function SidebarClient({sidebarMinMax = false}) {
  const [sot, setSot] = useState(false);

  return (
    <>
      <Link
        to={"/client/dashboard"}
        className={cx(
          "flex",
          "items-center",
          "gap-3",
          "px-4",
          "py-3",
          "rounded-lg",
          "text-gray-700",
          "hover:bg-blue-50",
          "hover:text-blue-700",
          "transition-all",
          "duration-200",
          "group",
          sidebarMinMax && "justify-center"
        )}
      >
        <LayoutDashboard className="w-5 h-5 text-gray-400 group-hover:text-blue-600" />
        {!sidebarMinMax && <span className="font-medium">Dashboard</span>}
      </Link>
      {sidebarMinMax ? (
        <Dropdown>
          <DropdownTrigger>
            <button
              className={cx(
                "w-full",
                "flex",
                "items-center",
                "justify-center",
                "px-4",
                "py-3",
                "rounded-lg",
                "text-gray-700",
                "hover:bg-gray-100",
                "transition-all",
                "duration-200",
                "group"
              )}
            >
              <FileText className="w-5 h-5 text-gray-400 group-hover:text-gray-600" />
            </button>
          </DropdownTrigger>
          <DropdownContent>
            <div className="bg-white rounded-lg shadow-lg border border-gray-200 py-2 min-w-[200px] mx-2 my-1">
              <DropdownItem>
                <Link
                  to={"/client/sot/all"}
                  className="flex items-center gap-3 px-3 py-2 text-sm text-gray-600 hover:text-blue-600 hover:bg-blue-50 rounded-md transition-all duration-200"
                >
                  <Eye className="w-4 h-4" />
                  All
                </Link>
              </DropdownItem>
            </div>
          </DropdownContent>
        </Dropdown>
      ) : (
        <>
          <button
            className={cx(
              "w-full",
              "flex",
              "items-center",
              "justify-between",
              "px-4",
              "py-3",
              "rounded-lg",
              "text-gray-700",
              "hover:bg-gray-100",
              "transition-all",
              "duration-200",
              "group"
            )}
            onClick={() => setSot(!sot)}
          >
            <div className="flex items-center gap-3">
              <FileText className="w-5 h-5 text-gray-400 group-hover:text-gray-600" />
              <span className="font-medium">Service Order</span>
            </div>
            <SidebarChevron />
          </button>
          {sot && (
            <div className={`flex flex-col px-[20px] gap-[20px]`}>
              <Link
                to={"/client/sot/all"}
                className={cx(
                  "flex",
                  "items-center",
                  "gap-3",
                  "px-3",
                  "py-2",
                  "text-sm",
                  "text-gray-600",
                  "hover:text-blue-600",
                  "hover:bg-blue-50",
                  "rounded-md",
                  "transition-all",
                  "duration-200"
                )}
              >
                <Eye className="w-4 h-4" />
                All
              </Link>
            </div>
          )}
        </>
      )}
    </>
  );
}
